import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { Icon, IconName } from '@shared/components/Icon';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import styles from './RowContent.module.css';

const DEFAULT_ICON_GRID_SIZE = 3;

export interface RowContentProps {
  children?: ReactNode;
  label?: ReactNode;
  numberOfLines?: number;
  startContent?: ReactNode;
  // none shows an empty space next to the label, so it can align with other
  // menu items that have icons
  icon?: IconName | 'none';
  /** Icon size in grid units. */
  iconGridSize?: number;
  endContent?: ReactNode;
}

export function RowContent({
  label,
  numberOfLines = 1,
  children,
  icon,
  iconGridSize = DEFAULT_ICON_GRID_SIZE,
  startContent,
  endContent,
}: RowContentProps) {
  const showStartContent = icon || startContent;
  const renderIcon = !isNil(icon) && icon !== 'none';
  return (
    <>
      {showStartContent && (
        <View className={styles.startContent} data-slot={'start'}>
          {!isNil(icon) && (
            <View className={styles.icon} data-slot="icon">
              {renderIcon && <Icon name={icon} gridSize={iconGridSize} />}
            </View>
          )}
          {isNil(icon) && startContent}
        </View>
      )}
      {label && (
        <View className={styles.label} data-slot="label">
          <Text size="body1" flex pretty numberOfLines={numberOfLines} data-slot="label-text">
            {label}
          </Text>
        </View>
      )}
      {!label && children}
      {endContent && (
        <View className={styles.endContent} data-slot="end">
          {endContent}
        </View>
      )}
    </>
  );
}
